import { useEffect, useRef } from "react";
import Header from "component/Header";
import Container from "component/Container";
import Footer from "component/Footer";
import ReactGA from "react-ga";

export default function HomePage() {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    ReactGA.pageview(window.location.pathname);
  }, []);

  return (
    <div>
      <Header containerRef={containerRef} />
      <Container containerRef={containerRef} />
      <Footer />
    </div>
  );
}
